import React, { FC } from "react";

import { useGlobalFilter, usePolicyholders } from "@/shared/hooks";

import { mapPolicyholderDropdownOption } from "../PolicyholderDropdown/utils";
import SelectedFilter from "./SelectedFilter";

const FilterChipList: FC = () => {
    const { policyholdersGF, setPolicyholdersGF } = useGlobalFilter();
    const { getPolicyholders } = usePolicyholders();

    const policyholders = getPolicyholders();

    const filters = mapPolicyholderDropdownOption(policyholders);

    const handleFilterSelection = (filterId: number) => {
        const index = policyholdersGF.indexOf(filterId, 0);
        if (index > -1) {
            const arrayCopy = [...policyholdersGF];
            arrayCopy.splice(index, 1);
            setPolicyholdersGF(arrayCopy);
        } else {
            setPolicyholdersGF([...policyholdersGF, filterId]);
        }
    };

    return (
        <>
            {filters
                .filter((f) => policyholdersGF.includes(f.id))
                .map((f) => (
                    <SelectedFilter
                        key={`filter-${f.id}`}
                        filterId={f.id}
                        label={f.name}
                        showRemoveIcon={policyholdersGF.length > 1}
                        onRemove={() => handleFilterSelection(f.id)}
                    />
                ))}
        </>
    );
};

export default FilterChipList;
